import event from '../../event/event';

export default event('/geopolitical/company-suppliers/show');
